export default class FontFamily {
  static apple = `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif`;

  static archivoBlack = "Archivo Black"; // ios bug when using this font
}
